<template>
  <div>
    <div class="Agreement-Content">
      <div class="close" @click="closeAgreement">×</div>
      <div class="conte">
        <section class="_editor" style="line-height: 0.4rem;font-size:0.28rem">
          <p style="text-align:center">
            <span style="font-size:0.48rem">共享经济合作伙伴协议</span>
          </p>
          <p style="margin-right:128px;text-align:right">
            <span style="font-family: &#39;Times New Roman&#39;,serif">&nbsp;</span>
          </p>
          <p style="text-indent:28px">
            <span style="font-size:0.28rem">《共享经济合作伙伴协议》（以下简称</span>
            <span style="font-size:0.28rem;font-family:&#39;Times New Roman&#39;,serif">“</span>
            <span style="font-size:0.28rem">本协议</span>
            <span style="font-size:0.28rem;font-family:&#39;Times New Roman&#39;,serif">”</span>
            <span style="font-size:0.28rem">）为</span>
            <span style="font-size:0.28rem">云账户（天津）共享经济信息咨询有限公司（以下简称</span>
            <span style="font-size:0.28rem;font-family:&#39;Times New Roman&#39;,serif">“</span>
            <span style="font-size:0.28rem">云账户</span>
            <span style="font-size:0.28rem;font-family:&#39;Times New Roman&#39;,serif">”</span>
            <span style="font-size:0.28rem">）与您（即本协议项下的</span>
            <span style="font-size:0.28rem">个体工商业者</span>
            <span
              style="font-size:0.28rem"
            >）签订的合作协议。如果您不同意本协议的任意内容，请不要勾选或以其他方式确认本协议；您点击勾选或以其他方式确认本协议，即表示您已充分阅读、理解并同意接受本协议的全部内容。</span>
          </p>
          <p style="text-indent:28px">
            <span style="font-family:宋体">感谢您选择云账户为</span>
            <span style="font-family:宋体;color:windowtext">您提供共享经济综合服务，</span>
            <span style="font-family:宋体">云账户</span>
            <span style="font-family: 宋体;color:windowtext">将</span>
            <span style="font-family:宋体;color:windowtext">依托综合实力</span>
            <span style="font-family:宋体;color:windowtext">竭诚为您提供</span>
            <span style="font-family:宋体;color:windowtext">规范、专业的服务。</span>
          </p>
          <p style="text-align: center;" class="m-title">
            <span style="font-family:&#39;Times New Roman&#39;,serif">&nbsp;</span>
          </p>
          <p style="text-align: center;" class="m-title">
            <em>
              <span
                style=";text-decoration:underline;;font-size:16px;font-family:宋体;color:windowtext"
              >特别声明：</span>
            </em>
          </p>
          <p style="text-indent:32px">
            <em>
              <span
                style=";text-decoration:underline;;font-size:16px;font-family:宋体;color:windowtext"
              >本协议项下的个体工商业者（即您）仅限于从事生产经营活动的个人，如您与企业客户存在劳动</span>
            </em>
            <em>
              <span
                style=";text-decoration:underline;;font-size:16px;font-family:&#39;Times New Roman&#39;,serif;color:windowtext"
              >/</span>
            </em>
            <em>
              <span
                style=";text-decoration:underline;;font-size:16px;font-family: 宋体;color:windowtext"
              >劳务关系或其他类似劳动人事法律关系或您担任企业客户（含关联方）的法定代表人、股东、董事、监事等，则您不能承揽云账户为满足该企业客户的业务需求而发布的任务。</span>
            </em>
          </p>
          <p style="text-indent:32px">
            <em>
              <span
                style=";text-decoration:underline;;font-size:16px;font-family:宋体;color:windowtext"
              >一经发现违反上述规定行为的，云账户有权取消您使用云账户服务的资格，并有权上报相关国家机关，由相关国家机关根据《中华人民共和国税收征收管理法》及其他相关法律法规的规定追究责任主体的法律责任。</span>
            </em>
          </p>
          <p style="margin-left:6px">
            <strong>
              <span style="font-family:&#39;Times New Roman&#39;,serif">&nbsp;</span>
            </strong>
          </p>
          <p style="text-align: center;" class="m-title">
            <strong>
              <span style="font-size:0.28rem">鉴于：</span>
            </strong>
          </p>
          <p style="text-indent:28px">
            <span style="font-family:宋体;color:windowtext">云账户具备共享经济资源平台及服务系统</span>
            <span style="font-family: 宋体;color:black">（</span>
            <span style="font-family: 宋体;color:black">以下称为</span>
            <span style="font-family:&#39;Times New Roman&#39;,serif;color:black">“</span>
            <span style="font-family:宋体;color:black">云账户综合服务平台</span>
            <span style="font-family:&#39;Times New Roman&#39;,serif;color:black">”</span>
            <span style="font-family:宋体;color:black">）</span>
            <span style="font-family: 宋体;color:windowtext">，</span>
            <span style="font-family:宋体;color:windowtext">可为</span>
            <span style="font-family:宋体;color:windowtext">您提供共享经济综合服务，主要包括基于您</span>
            <span style=";color:windowtext">的</span>
            <span style="font-family:宋体;color:windowtext">资质和劳动技能为您匹配适合的生产经营活动以及核算生产经营收入等。</span>
            <span style="font-family:宋体;color:windowtext">您与云账户依据《中华人民共和国合同法》</span>
            <span style="font-family: 宋体;color:windowtext">及</span>
            <span style="font-family:宋体;color:windowtext">相关法律法规</span>
            <span style="font-family:宋体;color:windowtext">的规定，</span>
            <span style="font-family:宋体;color:windowtext">本着平等、自愿、诚信的原则</span>
            <span style="font-family:宋体;color:windowtext">，</span>
            <span style="font-family:宋体;color:windowtext">在平等互利的基础上友好协商并签署本协议。</span>
          </p>
          <p style="text-indent:28px">
            <span style="font-family:&#39;Times New Roman&#39;,serif;color:windowtext">&nbsp;</span>
          </p>
          <p style="text-align: center;" class="m-title">
            <strong>
              <span style="font-family:宋体;color:black">第一条</span>
            </strong>
            <strong>
              <span style="font-family:&#39;Times New Roman&#39;,serif;color:black">&nbsp;</span>
            </strong>
            <strong>
              <span style="font-family:宋体;color:black">定义</span>
            </strong>
          </p>
          <p style="text-indent:28px">
            <span style="font-size:0.28rem;color:black">除非本</span>
            <span style="font-size: 0.28rem;color:black">协议</span>
            <span style="font-size:0.28rem;color:black">中另有定义，下列词语应具有以下特定涵义：</span>
          </p>
          <p style="margin-left:0;text-indent:28px">
            <span style="font-family:&#39;Times New Roman&#39;,serif;color:black">1、</span>
            <strong>
              <span style="font-family:宋体;color:black">关联方：</span>
            </strong>
            <span style="font-family:宋体;color:black">指相互间直接或间接持有其中一方的股权总和达到</span>
            <span style="font-family:&#39;Times New Roman&#39;,serif;color:black">25%</span>
            <span style="font-family:宋体;color:black">或以上的；或者直接或间接同为第三者所拥有或控制股权达到</span>
            <span style="font-family:&#39;Times New Roman&#39;,serif;color:black">25%</span>
            <span style="font-family:宋体;color:black">或以上的。如果一方通过中间方对另一方间接持有股份，只要其对中间方持股比例达到</span>
            <span style="font-family:&#39;Times New Roman&#39;,serif;color:black">25%</span>
            <span
              style="font-family:宋体;color:black"
            >以上，则其对另一方的持股比例按照中间方对另一方的持股比例计算；两个以上具有夫妻、直系血亲、兄弟姐妹以及其他抚养、赡养关系的自然人共同持股同一企业，在判定关联关系时持股比例合并计算。</span>
          </p>
          <p style="text-indent:28px">
            <span style="font-family:&#39;Times New Roman&#39;,serif;color:black">2</span>
            <span style="font-family:宋体;color:black">
              、
              <strong>个体工商业者：</strong>指
            </span>
            <span style="font-family:宋体;color:windowtext">自我雇佣、自我管理、自担成本、自负盈亏并通过云账户综合服务平台从事</span>
            <span style="font-family:宋体;color:black">合法合规生产经营活动的个人。</span>
          </p>
          <p style="text-indent:28px">
            <span style="font-family:&#39;Times New Roman&#39;,serif;color:black">3</span>
            <span style="font-family:宋体;color:black">
              、
              <strong>代征：</strong>指
            </span>
            <span style="font-family:宋体;color:windowtext">云账户</span>
            <span style="font-family:宋体;color:black">根</span>
            <span style="font-family: 宋体;color:black">据</span>
            <span style="font-family:宋体;color:black">《</span>
            <span style="font-family: 宋体;color:black">委托</span>
            <span style="font-family:宋体;color:black">代征</span>
            <span style="font-family: 宋体;color:black">协议书</span>
            <span style="font-family:宋体;color:black">》的有关</span>
            <span style="font-family:宋体;color:black">规定，</span>
            <span style="font-family:宋体;color:black">接受</span>
            <span style="font-family: 宋体;color:windowtext">云账户</span>
            <span style="font-family:宋体;color:black">主管税务机关的委托，以</span>
            <span style="font-family:宋体;color:windowtext">云账户</span>
            <span style="font-family:宋体;color:black">主管税务机关的名义向从事生产经营活动的个人征收应缴纳的个人所得税的行为。</span>
          </p>
          <p style="text-indent:28px">
            <span
              style="font-size:0.28rem;font-family:&#39;Times New Roman&#39;,serif;color:black"
            >4</span>
            <span style="font-size:0.28rem;color:black">
              、
              <strong>生产经营收入（</strong>
            </span>
            <strong>
              <span style="font-size:0.28rem;color:black">税后）：</span>
            </strong>
            <span style="font-size:0.28rem;color:black">指您</span>
            <span style="font-size:0.28rem;color:black">从事</span>
            <span style="font-size:0.28rem;color:black">生产经营活动</span>
            <span style="font-size:0.28rem;color:black">而取得的税后收入。</span>
          </p>
          <p style="text-indent:28px">
            <span
              style="font-size:0.28rem;font-family:&#39;Times New Roman&#39;,serif;color:black"
            >5</span>
            <span style="font-size:0.28rem;color:black">
              、
              <strong>服务费：</strong>指由
            </span>
            <span style="font-size:0.28rem">云账户</span>
            <span style="font-size:0.28rem;color:black">向企业客户提供共享经济综合服务，</span>
            <span style="font-size:0.28rem">云账户</span>
            <span style="font-size:0.28rem;color:black">就该等服务向企业客户收取的费用。</span>
          </p>
          <p style="text-indent:32px">
            <span style="font-family:&#39;Times New Roman&#39;,serif">&nbsp;</span>
          </p>
          <p style="text-align: center;" class="m-title">
            <strong>
              <span style="font-family:宋体;color:windowtext">第</span>
            </strong>
            <strong>
              <span style="font-family:宋体;color:windowtext">二</span>
            </strong>
            <strong>
              <span style="font-family:宋体;color:windowtext">条</span>
            </strong>
            <strong></strong>
            <strong>
              <span style="font-family:宋体;color:windowtext">合作内容</span>
            </strong>
          </p>
          <p style="text-indent:28px">
            <span style="font-family:&#39;Times New Roman&#39;,serif;color:windowtext">1</span>
            <span
              style="font-family: 宋体;color:windowtext"
            >、云账户为满足企业客户的业务需求而通过云账户综合服务平台向适合个体工商业者发布任务，您可根据自身资质和劳动技能选择是否接受前述活动。</span>
          </p>
          <p style="text-indent:28px">
            <span style="font-family:&#39;Times New Roman&#39;,serif;color:windowtext">2</span>
            <span style="font-family:宋体;color:windowtext">、</span>
            <span
              style="font-family:宋体;color:windowtext"
            >云账户通过云账户综合服务平台公布活动内容、活动规则等，您可据此查询、接受活动内容，并承诺在从事生产经营活动过程中遵守前述活动规则、承担相关义务；云账户根据您任务完成的数量和质效核算、支付您的生产经营收入（税后）</span>
            <span style="font-family:宋体;color:windowtext">。</span>
          </p>
          <p style="text-indent:28px">
            <span style="font-family:&#39;Times New Roman&#39;,serif;color:windowtext">3</span>
            <span style="font-family: 宋体;color:windowtext">、</span>
            <span style="font-family:宋体;color:windowtext">您</span>
            <span style="font-family:宋体;color:windowtext">委托</span>
            <span
              style="font-family:宋体;color:windowtext"
            >云账户按照有关税收法律法规、政策规定及云账户主管税务机关的要求为您代征个人所得税税款。</span>
          </p>
          <p style="text-indent:28px">
            <span style="font-family:&#39;Times New Roman&#39;,serif">&nbsp;</span>
          </p>
          <p style="text-align: center;" class="m-title">
            <strong>
              <span style="font-family:宋体;color:windowtext">第</span>
            </strong>
            <strong>
              <span style="font-family:宋体;color:windowtext">三</span>
            </strong>
            <strong>
              <span style="font-family:宋体;color:windowtext">条</span>
            </strong>
            <strong></strong>
            <strong>
              <span style="font-family:宋体;color:windowtext">生产经营收入（税后）的结算及支付方式</span>
            </strong>
          </p>
          <p style="text-indent:28px">
            <span style="font-family:&#39;Times New Roman&#39;,serif;color:windowtext">1</span>
            <span style="font-family: 宋体;color:windowtext">、根据云账户与企业客户签署的《共享经济综合服务协议》的</span>
            <span style="font-family:宋体;color:windowtext">约</span>
            <span style="font-family:宋体;color:windowtext">定，云账户</span>
            <span style="font-family:宋体;color:black">基于企业客户业务需求所对应的活动内容及费用标准</span>
            <span style="font-family:宋体;color:windowtext">向企业客户提供共享经济综合服务并收取服务费。云账户</span>
            <span style="font-family:宋体;color:windowtext">收到企业客户支付的服务费后，</span>
            <span style="font-family:宋体;color:windowtext">将</span>
            <span style="font-family: 宋体;color:windowtext">根据</span>
            <span style="font-family:宋体;color:windowtext">您</span>
            <span style="font-family:宋体;color:windowtext">任务完成</span>
            <span style="font-family:宋体;color:windowtext">的数量和质效核算、支付</span>
            <span style="font-family:宋体;color:windowtext">您的</span>
            <span style="font-family: 宋体;color:windowtext">生产经营收入</span>
            <span style="font-family:宋体;color:black">（</span>
            <span style="font-family: 宋体;color:black">税后）</span>
            <span style="font-family:宋体;color:windowtext">。</span>
          </p>
          <p style="text-indent:28px">
            <span
              style="font-size:0.28rem;font-family:&#39;Times New Roman&#39;,serif;color:black"
            >2</span>
            <span style="font-size:0.28rem;color:black">、您应自行负担就您取得的生产经营收入需缴纳的各项税款，应</span>
            <span style="font-size:0.28rem">云账户</span>
            <span
              style="font-size:0.28rem;color:black"
            >要求，您应提供与个人所得税申报缴纳相关的协助及信息；云账户承诺依法代征个人所得税并确保您取得</span>
            <span style="font-size:0.28rem;color:black">税后合法收入。</span>
          </p>
          <p style="text-indent:28px">
            <span
              style="font-size:0.28rem;font-family:&#39;Times New Roman&#39;,serif;color:black"
            >&nbsp;</span>
          </p>
          <p style="text-align: center;" class="m-title">
            <strong>
              <span style="font-family:宋体;color:windowtext">第</span>
            </strong>
            <strong>
              <span style="font-family: 宋体;color:windowtext">四</span>
            </strong>
            <strong>
              <span style="font-family:宋体;color:windowtext">条</span>
            </strong>
            <strong></strong>
            <strong>
              <span style="font-family: 宋体;color:windowtext">您的权利与义务</span>
            </strong>
          </p>
          <p style="margin-left:0;text-indent:28px">
            <span style="font-family:&#39;Times New Roman&#39;,serif;color:windowtext">1、</span>
            <span
              style="font-family:宋体;color:windowtext"
            >您保证签署本协议时具有完全民事权利能力和民事行为能力或系已满十六周岁未满十八周岁经法定监护人同意的民事主体，并满足所有履行本协议所需的法定条件或约定条件，保证在从事</span>
            <span style="font-family:宋体;color:windowtext">生产经营活动</span>
            <span style="font-family:宋体;color:windowtext">时，</span>
            <span style="font-family:宋体;color:windowtext">遵照</span>
            <span style="font-family:宋体;color:windowtext">相关活动</span>
            <span style="font-family:宋体;color:windowtext">规则</span>
            <span style="font-family:宋体;color:windowtext">并</span>
            <span style="font-family:宋体;color:windowtext">自备所需要的设备设施、自行承担必要费用，</span>
            <span style="font-family:宋体;color:windowtext">如</span>
            <span style="font-family:宋体;color:windowtext">因您个人原因造成您本人或任</span>
            <span style="font-family:宋体;color:windowtext">意</span>
            <span style="font-family:宋体;color:windowtext">第三方损害的，由您承担全部法律责任。</span>
          </p>
          <p style="margin-left:0;text-indent:28px">
            <span style="font-family:&#39;Times New Roman&#39;,serif;color:windowtext">2、</span>
            <span
              style="font-family:宋体;color:windowtext"
            >您保证具有从事云账户发布的生产经营活动的资质和劳动技能。如果您所从事的生产经营活动需经相关国家机关许可或以其他方式进行的，您应先行取得相关许可并按照法律规定的方式从事生产经营活动，否则您应自行承担全部法律后果，并赔偿由此给云账户造成的全部损失。</span>
          </p>
          <p style="text-indent:28px">
            <span style="font-family:&#39;Times New Roman&#39;,serif;color:windowtext">3</span>
            <span style="font-family:宋体;color:windowtext">、您</span>
            <span style="font-family:宋体;color:windowtext">有权在</span>
            <span style="font-family:宋体;color:windowtext">云账户</span>
            <span style="font-family:宋体;color:windowtext">处查询生产经营</span>
            <span style="font-family:宋体;color:windowtext">收入</span>
            <span style="font-family:宋体;color:black">（</span>
            <span style="font-family:宋体;color:black">税后）</span>
            <span style="font-family:宋体;color:windowtext">的核算方式、取得生产经营</span>
            <span style="font-family:宋体;color:windowtext">收入</span>
            <span style="font-family:宋体;color:black">（</span>
            <span style="font-family: 宋体;color:black">税后）。</span>
            <span style="font-family:宋体;color:windowtext">您</span>
            <span
              style="font-family:宋体;color:windowtext"
            >保证所从事的生产经营活动是以您个人名义进行的，与您名下的个体工商户（如有）没有任何关系；您保证不以云账户的名义从事任何与本协议项下的生产经营活动无关的业务。</span>
          </p>
          <p style="text-indent:28px">
            <span style="font-family:&#39;Times New Roman&#39;,serif;color:windowtext">4</span>
            <span style="font-family:宋体;color:windowtext">、您保证在生产经营活动过程中遵守国家法律法规，不得从事违反法律或行政法规等行为（包括</span>
            <span style="font-family:宋体;color:windowtext">但</span>
            <span style="font-family:宋体;color:windowtext">不限于涉嫌洗钱、偷税、漏税、逃税）及其他不得使用云账户服务的行为，云账户</span>
            <span style="font-family:宋体;color:windowtext">主管</span>
            <span style="font-family:宋体;color:windowtext">税务机关或</span>
            <span style="font-family:&#39;Times New Roman&#39;,serif;color:windowtext">/</span>
            <span style="font-family:宋体;color:windowtext">及</span>
            <span style="font-family:宋体">其他相关国家机关</span>
            <span style="font-family:宋体;color:windowtext">介入调查时，您应当予以协助</span>
            <span style="font-family:宋体;color:windowtext">并</span>
            <span style="font-family:宋体;color:windowtext">如实反映情况，不得阻挠、拒绝调查。</span>
          </p>
          <p style="text-indent:28px">
            <span style="font-family:&#39;Times New Roman&#39;,serif;color:windowtext">5</span>
            <span style="font-family:宋体;color:windowtext">、您</span>
            <span style="font-family:宋体;color:windowtext">充分理解个体工商业者的定义</span>
            <span style="font-family:宋体;color:black">，并</span>
            <span style="font-family: 宋体;color:windowtext">承诺不</span>
            <span style="font-family:宋体;color:windowtext">存在下列所述情形</span>
            <span style="font-family:宋体;color:windowtext">：</span>
          </p>
          <p style="text-indent:28px">
            <span style="font-family:&#39;Times New Roman&#39;,serif;color:windowtext">5.1</span>
            <span style="font-family:宋体;color:windowtext">承揽的生产经营活动系云账户为满足与您存在劳动</span>
            <span style="font-family:&#39;Times New Roman&#39;,serif;color:windowtext">/</span>
            <span style="font-family:宋体;color:windowtext">劳务关系或其他类似的劳动人事法律关系的企业客户的业务需求而发布的；</span>
          </p>
          <p style="text-indent:28px">
            <span style="font-family:&#39;Times New Roman&#39;,serif;color:windowtext">5.2</span>
            <span style="font-family:宋体;color:windowtext">承揽的生产经营活动系云账户为满足由您担任</span>
            <span style="font-family:宋体;color:windowtext">法定代表人、股东、董事、监事等的企业客户（含关联方）的业务需求而发布的；</span>
          </p>
          <p style="text-indent:28px">
            <span style="font-family:&#39;Times New Roman&#39;,serif;color:windowtext">5.3</span>
            <span style="font-family:宋体;color:windowtext">其他不适用于</span>
            <span style="font-family:宋体;color:windowtext">云账户</span>
            <span style="font-family:宋体;color:windowtext">服务范围之规定的人员。</span>
          </p>
          <p style="text-indent:28px">
            <span style="font-family:&#39;Times New Roman&#39;,serif;color:windowtext">6</span>
            <span
              style="font-family:宋体;color:windowtext"
            >、您保证向云账户提供的信息均是真实的、有效的、合法的，如信息发生变更（例如，不再是个体工商业者身份时）应及</span>
            <span style="font-family:宋体;color:windowtext">时通知云账户，</span>
            <span style="font-family:宋体;color:windowtext">否则因此造成的一切不利后果由您承担</span>
            <span
              style="font-family:宋体;color:windowtext"
            >。您的账户信息以您实名提交至云账户综合服务平台后台的信息为准，且您保证该账户为纳税义务人（即您本人）所有。自</span>
            <span style="font-family:宋体;color:windowtext">云账户</span>
            <span style="font-family:宋体;color:windowtext">将应支付的</span>
            <span style="font-family:宋体;color:windowtext">生产经营</span>
            <span style="font-family:宋体;color:windowtext">收入</span>
            <span style="font-family:宋体;color:black">（</span>
            <span style="font-family:宋体;color:black">税后）</span>
            <span
              style="font-family:宋体;color:windowtext"
            >支付至您的账户之日起，视为您收到前述费用。如因您提供信息有误等导致付款失败的，您独自承担相应责任。您承诺使用前述账户的行为符合中华人民共和国法律的规定，如果</span>
            <span style="font-family:宋体;color:windowtext">云账户</span>
            <span style="font-family:宋体;color:windowtext">收到</span>
            <span style="font-family:宋体;color:windowtext">云账户</span>
            <span style="font-family:宋体;color:black">主管税务机关或</span>
            <span style="font-family:&#39;Times New Roman&#39;,serif;color:black">/</span>
            <span style="font-family:宋体;color:black">及其他相关国家机关</span>
            <span style="font-family:宋体;color:windowtext">任何调查请求的，您应提供协助并如实反映情况。</span>
          </p>
          <p style="text-indent:28px">
            <span style="font-family:&#39;Times New Roman&#39;,serif;color:windowtext">7</span>
            <span
              style="font-family:宋体;color:windowtext"
            >、您须谨慎保管于云账户处注册时所使用的相关信息（包括但不限于账户信息、身份凭证），因您泄露或提供给他人使用该等</span>
            <span style="font-family:宋体;color:windowtext">信息</span>
            <span style="font-family:宋体;color:windowtext">而造成的不利后果，由您自行承担。</span>
            <span style="font-family:宋体;color:black">您应根据相关法律法规或政策积极办理“个体工商业者”市场主体的身份登记事宜，可由云账户提供便利。</span>
          </p>
          <p style="text-indent:28px">
            <span style="font-family:&#39;Times New Roman&#39;,serif;color:windowtext">8</span>
            <span
              style="font-family:宋体;color:windowtext"
            >、您同意并授权云账户为实现本协议合作目的留存并合法使用您的个人信息（包括但不限于您的姓名、身份证号、收款账户信息、活动内容及费用），如云账户收集、存储的</span>
            <span style="font-family:宋体;color:windowtext">您的</span>
            <span style="font-family:宋体;color:windowtext">个人信息有错误的，</span>
            <span style="font-family:宋体;color:windowtext">您</span>
            <span style="font-family:宋体;color:windowtext">有权要求予以更正；</span>
            <span style="font-family:宋体;color:windowtext">如</span>
            <span style="font-family:宋体;color:windowtext">云账户</span>
            <span style="font-family: 宋体;color:windowtext">违反法律、行政法规的规定或者双方的约定收集、使用</span>
            <span style="font-family:宋体;color:windowtext">您的</span>
            <span style="font-family:宋体;color:windowtext">个人信息的，</span>
            <span style="font-family:宋体;color:windowtext">您</span>
            <span style="font-family:宋体;color:windowtext">有权要求予以删除。</span>
          </p>
          <p style="text-indent:28px">
            <span style="font-family:&#39;Times New Roman&#39;,serif;color:windowtext">9</span>
            <span
              style="font-family: 宋体;color:windowtext"
            >、您应当本着云账户利益最大化的原则，勤勉履行本协议，维护云账户形象，不得损害云账户的合法权益。</span>
          </p>
          <p style="text-indent:28px">
            <span style="font-family:&#39;Times New Roman&#39;,serif;color:windowtext">&nbsp;</span>
          </p>
          <p style="text-align: center;" class="m-title">
            <strong>
              <span style="font-family:宋体;color:windowtext">第</span>
            </strong>
            <strong>
              <span style="font-family:宋体;color:windowtext">五</span>
            </strong>
            <strong>
              <span style="font-family:宋体;color:windowtext">条</span>
            </strong>
            <strong></strong>
            <strong>
              <span style="font-family:宋体;color:windowtext">云账户的权利与义务</span>
            </strong>
          </p>
          <p style="text-indent:28px">
            <span style="font-family:&#39;Times New Roman&#39;,serif;color:windowtext">1</span>
            <span style="font-family: 宋体;color:windowtext">、基于</span>
            <span style="font-family:宋体;color:windowtext">企业客户的业务需求及您</span>
            <span style=";color:windowtext">的</span>
            <span style="font-family:宋体;color:windowtext">资质和劳动技能，云账户</span>
            <span style="font-family:宋体;color:windowtext">有权</span>
            <span style="font-family:宋体;color:black">就</span>
            <span style="font-family:宋体;color:black">您</span>
            <span style="font-family:宋体;color:black">从事的</span>
            <span style="font-family:宋体;color:black">生产</span>
            <span style="font-family: 宋体;color:black">经营活动制定相应的活动标准，</span>
            <span style="font-family:宋体;color:windowtext">云账户应</span>
            <span style="font-family:宋体;color:black">敦促</span>
            <span style="font-family:宋体;color:black">您遵守前述活动标准并</span>
            <span style="font-family:宋体;color:black">不得违背相关法律法规和前述活动标准，</span>
            <span style="font-family:宋体;color:black">但</span>
            <span style="font-family: 宋体;color:black">该等敦促为平等主体之间为实现合同目的的敦促，</span>
            <span style="font-family:宋体;color:black">适用</span>
            <span style="font-family: 宋体;color:windowtext">《中华人民共和国合同法》约束</span>
            <span style="font-family:宋体;color:black">，且不导致</span>
            <span style="font-family:宋体;color:windowtext">云账户</span>
            <span style="font-family:宋体;color:black">与您</span>
            <span style="font-family:宋体;color:black">之间构成劳动</span>
            <span style="font-family:&#39;Times New Roman&#39;,serif;color:black">/</span>
            <span style="font-family:宋体;color:black">劳务关系。</span>
          </p>
          <p style="text-indent:28px">
            <span style="font-family:&#39;Times New Roman&#39;,serif;color:black">2</span>
            <span style="font-family:宋体;color:black">、</span>
            <span
              style="font-family:宋体;color:windowtext"
            >在企业客户及时、足额向云账户支付服务费的情况下，您发起的生产经营收入的提现或支付申请，由云账户根据您任务完成的数量和质效核算、支付您的生产经营收入（税后）（您从事的生产经营活动超出云账户发布任务的除外）。</span>
          </p>
          <p style="text-indent:28px">
            <span style="font-family:&#39;Times New Roman&#39;,serif;color:windowtext">3</span>
            <span
              style="font-family: 宋体;color:windowtext"
            >、云账户有权根据相关法律法规或政策，推进您“个体工商业者”市场主体的身份登记事宜并积极提供便利。</span>
          </p>
          <p style="text-indent:28px">
            <span style="font-family:&#39;Times New Roman&#39;,serif;color:windowtext">4</span>
            <span style="font-family: 宋体;color:windowtext">、云账户在向您支付生产经营</span>
            <span style="font-family:宋体;color:windowtext">收入</span>
            <span style="font-family:宋体;color:black">（</span>
            <span style="font-family: 宋体;color:black">税后）</span>
            <span style="font-family:宋体;color:windowtext">时，</span>
            <span style="font-family:宋体;color:black">有权在</span>
            <span style="font-family:宋体;color:windowtext">云账户</span>
            <span style="font-family:宋体;color:black">所在地向</span>
            <span style="font-family:宋体;color:windowtext">云账户</span>
            <span style="font-family:宋体;color:black">主管税务机关代</span>
            <span style="font-family:宋体;color:black">您</span>
            <span style="font-family:宋体;color:black">进行临时税务登记，</span>
            <span style="font-family:宋体;color:black">并</span>
            <span style="font-family:宋体;color:windowtext">按照有关税收政策规定及云账户主管税务机关的要求，向您代征个人所得税税款。</span>
          </p>
          <p style="text-indent:28px">
            <span style="font-size:0.28rem;font-family:&#39;Times New Roman&#39;,serif">5</span>
            <span style="font-size:0.28rem">、</span>
            <span style="font-size:0.28rem">云账户</span>
            <span style="font-size:0.28rem">发现您违反本协议第</span>
            <span style="font-size:0.28rem">四</span>
            <span style="font-size:0.28rem">条第</span>
            <span style="font-size:0.28rem;font-family:&#39;Times New Roman&#39;,serif">5</span>
            <span style="font-size:0.28rem">款之</span>
            <span style="font-size:0.28rem">约</span>
            <span style="font-size:0.28rem">定的，</span>
            <span style="font-size:0.28rem">有权立即中止</span>
            <span style="font-size: 0.28rem">履行本协议，</span>
            <span style="font-size:0.28rem">并向</span>
            <span style="font-size:0.28rem">云账户</span>
            <span style="font-size:0.28rem">
              主管税务机关报告
              <span style="color:black">，</span>您应自行承担由此产生的税务相关的处罚责任（包括但不限于根据
            </span>
            <span style="font-size:0.28rem">云账户</span>
            <span style="font-size:0.28rem">主管税务机关的要求补缴相应的税款、滞纳金、罚金）。</span>
          </p>
          <p style="text-indent:28px">
            <span style="font-family:&#39;Times New Roman&#39;,serif;color:windowtext">6</span>
            <span style="font-family:宋体;color:windowtext">、云账户有权留存并合法使用为实现本协议合作目的从您处获取的您的个人信息，云账户</span>
            <span style="font-family:宋体;color:windowtext">（含股东会、董事会、监事会成员及高级管理人员）</span>
            <span
              style="font-family: 宋体;color:windowtext"
            >承诺对您所披露的个人信息进行保密，未经您授权或基于合法并可执行的法律、法规、法院命令、监管机构的要求或为遵守适用法律法规、履行网络安全保护义务或应对网络安全事件的需要，云账户</span>
            <span style="font-family:宋体;color:black">（含股东会、董事会、监事会成员及高级管理人员）</span>
            <span style="font-family:宋体;color:windowtext">不得将您的个人信息披露给任</span>
            <span style="font-family:宋体;color:windowtext">意</span>
            <span
              style="font-family:宋体;color:windowtext"
            >第三方。云账户承诺按照相关法律法规的要求对您的个人信息履行安全保护义务，保障网络免受干扰、破坏或未经授权的访问，防止网络数据泄露或被窃取、篡改。</span>
          </p>
          <p style="text-indent:28px">
            <span style="font-family:&#39;Times New Roman&#39;,serif;color:windowtext">7</span>
            <span
              style="font-family: 宋体;color:windowtext"
            >、云账户因网络服务的特殊性需短时间中断服务对系统进行维护和升级，您理解并认可前述行为不属于云账户违约情形。</span>
          </p>
          <p style="text-indent:28px">
            <span style="font-family:&#39;Times New Roman&#39;,serif;color:black">8</span>
            <span style="font-family:宋体;color:black">、云账户可为</span>
            <span style=";color:black">您</span>
            <span style="font-family: 宋体;color:black">提供养老保险的缴纳等</span>
            <span style=";color:black">服务</span>
            <span style="font-family:宋体;color:black">，具体服务细则由双方另行</span>
            <span style=";color:black">约定</span>
            <span style="font-family:宋体;color:black">。</span>
          </p>
          <p style="text-indent:28px">
            <span style="font-family:&#39;Times New Roman&#39;,serif;color:black">9</span>
            <span style="font-family:宋体;color:black">、</span>
            <span style=";color:black">云账户</span>
            <span style="font-family:宋体;color:windowtext">应当本着</span>
            <span style="font-family:宋体;color:windowtext">您</span>
            <span style="font-family:宋体;color:windowtext">利益最大化</span>
            <span style=";color:windowtext">的</span>
            <span style="font-family: 宋体;color:windowtext">原则，勤勉履行本协议，不得损害</span>
            <span style="font-family:宋体;color:windowtext">您</span>
            <span style="font-family:宋体;color:windowtext">的合法权益。</span>
          </p>
          <p style="text-indent:28px">
            <span style="font-family:&#39;Times New Roman&#39;,serif;color:black">&nbsp;</span>
          </p>
          <p style="text-align: center;" class="m-title">
            <strong>
              <span style="font-family:宋体;color:windowtext">第</span>
            </strong>
            <strong>
              <span style="font-family:宋体;color:windowtext">六</span>
            </strong>
            <strong>
              <span style="font-family:宋体;color:windowtext">条</span>
            </strong>
            <strong></strong>
            <strong>
              <span style="font-family:宋体;color:windowtext">违约责任</span>
            </strong>
          </p>
          <p style="text-indent:28px">
            <span style="font-family:&#39;Times New Roman&#39;,serif;color:windowtext">1</span>
            <span style="font-family:宋体;color:windowtext">、</span>
            <span style="font-family:宋体;color:windowtext">除本协议另有约定外，本协议任</span>
            <span style="font-family:宋体;color:windowtext">意</span>
            <span
              style="font-family:宋体;color:windowtext"
            >一方不履行或不完全履行本协议约定的义务和承诺即构成违约。违约方应当负责赔偿其违约行为给守约方造成的一切经济损失（包括但不限于合理的律师费、诉讼费、公证费）。</span>
          </p>
          <p style="text-indent:28px">
            <span style="font-family: &#39;Times New Roman&#39;,serif;color:black">2</span>
            <span style="font-family:宋体;color:black">、</span>
            <span style="font-family:宋体;color:black">因政府行为（</span>
            <span style="font-family:宋体;color:black">包括但不限于</span>
            <span style="font-family: 宋体;color:black">因中国政府机关不授予或</span>
            <span style="font-family:宋体;color:black">调整</span>
            <span style="font-family: 宋体;color:windowtext">云账户</span>
            <span style="font-family:宋体;color:black">相应经营资质或权利</span>
            <span style="font-family:宋体;color:black">）</span>
            <span style="font-family: 宋体;color:black">或其他不可抗力因素导致本协议部分条款或全部条款无法履行的，遭受该行为的一方不承担违约责任。</span>
          </p>
          <p style="text-align: center;" class="m-title">
            <span style="font-family:&#39;Times New Roman&#39;,serif">&nbsp;</span>
          </p>
          <p style="text-align: center;" class="m-title">
            <strong>
              <span style="font-family:宋体;color:windowtext">第</span>
            </strong>
            <strong>
              <span style="font-family:宋体;color:windowtext">七</span>
            </strong>
            <strong>
              <span style="font-family:宋体;color:windowtext">条</span>
            </strong>
            <strong></strong>
            <strong>
              <span style="font-family:宋体;color:windowtext">保密责任</span>
            </strong>
          </p>
          <p style="text-indent:28px">
            <span style="font-family:&#39;Times New Roman&#39;,serif;color:windowtext">1</span>
            <span style="font-family: 宋体;color:windowtext">、本协议任</span>
            <span style="font-family:宋体;color:windowtext">意</span>
            <span style="font-family:宋体;color:windowtext">一方应对本协议所涉及的所有内容以及协议</span>
            <span style="font-family: 宋体;color:windowtext">双</span>
            <span style="font-family:宋体;color:windowtext">方在执行本协议过程中相关的法律、商业、合作业务的所有</span>
            <span style="font-family:宋体;color:windowtext">信息</span>
            <span style="font-family:宋体;color:windowtext">进行保密。未经对方允许，均不得向任意第三方披露。</span>
          </p>
          <p style="text-indent:28px">
            <span style="font-family:&#39;Times New Roman&#39;,serif;color:windowtext">2</span>
            <span style="font-family: 宋体;color:windowtext">、保密期</span>
            <span style="font-family:宋体;color:windowtext">限</span>
            <span style="font-family:宋体;color:windowtext">应为：</span>
            <span style="font-family:宋体;color:black">自协议生效之日</span>
            <span style="font-family:宋体;color:black">起</span>
            <span style="font-family:宋体;color:black">至协议终止后十年</span>
            <span style="font-family:宋体;color:windowtext">。</span>
          </p>
          <p style="text-indent:28px">
            <span style="font-family:&#39;Times New Roman&#39;,serif;color:windowtext">&nbsp;</span>
          </p>
          <p style="text-align: center;" class="m-title">
            <strong>
              <span style="font-family:宋体;color:windowtext">第</span>
            </strong>
            <strong>
              <span style="font-family:宋体;color:windowtext">八</span>
            </strong>
            <strong>
              <span style="font-family:宋体;color:windowtext">条</span>
            </strong>
            <strong></strong>
            <strong>
              <span style="font-family:宋体;color:windowtext">适用法律、争议及纠纷解决和司法管辖</span>
            </strong>
          </p>
          <p style="text-indent:28px">
            <span style="font-family:宋体;color:windowtext">本协议的订立、执行、解释和争议的解决均应适用中</span>
            <span style="font-family: 宋体;color:windowtext">华人民共和</span>
            <span style="font-family:宋体;color:windowtext">国境内法律。凡因本协议引起的或与本协议有关的任何争议，协议</span>
            <span style="font-family:宋体;color:windowtext">双</span>
            <span style="font-family:宋体;color:windowtext">方应友好协商解决。如不能协商解决，双方一致同意</span>
            <span style="font-family: 宋体;color:windowtext">提交至被告所在地</span>
            <span style="font-family:宋体;color:windowtext">有管辖权的人民法院诉讼解决。</span>
          </p>
          <p style="text-align: center;" class="m-title">
            <span style="font-family:&#39;Times New Roman&#39;,serif;color:windowtext">&nbsp;</span>
          </p>
          <p style="text-align: center;" class="m-title">
            <strong>
              <span style="font-family:宋体;color:windowtext">第九条</span>
            </strong>
            <strong></strong>
            <strong>
              <span style="font-family:宋体;color:windowtext">通知</span>
            </strong>
          </p>
          <p style="text-indent:28px">
            <span
              style="font-family:宋体;color:windowtext"
            >除本协议另有约定外，在履行本协议过程中的一切通知，云账户可通过网页公告、电子邮件、系统通知、短信提醒、电话或其他合理方式向您送达</span>
            <span style="font-family:宋体">，您可通过拨打服务热线（</span>
            <span style="font-family:&#39;Times New Roman&#39;,serif;color:windowtext">400 656 5739</span>
            <span style="font-family:宋体">）的方式向云账户送达，</span>
            <span style="font-family:宋体;color:windowtext">该等通知于发送之日视为已送达收件人。</span>
          </p>
          <p style="text-indent:28px">
            <span style="font-family:&#39;Times New Roman&#39;,serif;color:windowtext">&nbsp;</span>
          </p>
          <p style="text-align: center;" class="m-title">
            <strong>
              <span style="font-size:0.28rem">第十条</span>
            </strong>
            <strong></strong>
            <strong>
              <span style="font-size:0.28rem">协议的变更与终止</span>
            </strong>
          </p>
          <p style="text-indent:28px">
            <span style="font-size:0.28rem;font-family:&#39;Times New Roman&#39;,serif">1</span>
            <span style="font-size:0.28rem">、</span>
            <span style="font-size:0.28rem">云账户</span>
            <span style="font-size:0.28rem">有权根据需要不定期更新本协议条款，并在企业客户</span>
            <span style="font-size:0.28rem;font-family:&#39;Times New Roman&#39;,serif">APP</span>
            <span style="font-size:0.28rem">、小程序或以其他方式予以公布。如您同意所修改的内容，请点击勾选或以其他方式确认继续使用</span>
            <span style="font-size:0.28rem">云账户</span>
            <span style="font-size:0.28rem">服务；如您不同意所修改的内容，请立即停止使用</span>
            <span style="font-size:0.28rem">云账户</span>
            <span style="font-size:0.28rem">服务，并可自行注销账户信息。</span>
          </p>
          <p style="text-indent:28px">
            <span style="font-size:0.28rem;font-family:&#39;Times New Roman&#39;,serif">2</span>
            <span style="font-size:0.28rem">、您应遵守本协议约定、相关法律法规的规定及社会公序良俗，云账户有权自主判断您的行为是否违约或</span>
            <span style="font-size:0.28rem;font-family:&#39;Times New Roman&#39;,serif">/</span>
            <span style="font-size:0.28rem">及违规。发生下列情形时云账户有权在不事先通知的情况下，限制、停止或取消您使用云账户服务的资格。</span>
          </p>
          <p style="text-align:justify;text-justify:inter-ideograph;text-indent:28px">
            <span style="font-size:0.28rem;font-family:&#39;Times New Roman&#39;,serif">2.1</span>
            <span
              style="font-size:0.28rem"
            >如云账户有合理理由或有证据认定您违反本协议或相关法律法规及社会公序良俗的【包括但不限于有伤社会风化、有损公民身心健康与安全的行为（如</span>
            <span style="font-size:0.28rem;color:black;background:white">传销、赌博、暴力、淫秽、恐怖行为等</span>
            <span style="font-size:0.28rem">）】；</span>
          </p>
          <p style="text-indent:28px">
            <span style="font-size:0.28rem;color:black">2.2</span>
            <span style="font-size:0.28rem;color:black">您违反云账户的活动规则等，且在云账户警告后3个工作日内仍未改正的；</span>
          </p>
          <p style="text-indent:28px">
            <span style="font-size:0.28rem;color:black">2.3</span>
            <span style="font-size:0.28rem;color:black">其他原因导致本协议无法继续履行的。</span>
          </p>
          <p style="text-align:center;text-indent:28px">
            <span style="font-size:0.28rem;font-family:&#39;Times New Roman&#39;,serif">&nbsp;</span>
          </p>
          <p style="text-align: center;" class="m-title">
            <br />
          </p>
        </section>
      </div>
      <van-button type="primary" size="large" @click="closeAgreement">关闭</van-button>
    </div>
  </div>
</template>

<script>
import { Button } from "vant";
export default {
  name: "Agreement",
  data() {
    return {
      msg: "用户服务协议"
    };
  },
  methods: {
    closeAgreement: function() {
      this.$emit("set-agreement-hide");
    }
  },
  components: {
    "van-button": Button
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang='less'>
@import "~@/assets/less/common.less";
@import "~@/assets/less/mixin.less";
.Agreement-Content {
  padding: 0.8rem 0.3rem;
  line-height: 1.4;
  .close {
    font-size: 0.8rem;
    right: 0.2rem;
    top: -0.2rem;
    position: fixed;
  }
}
.conte {
  .m-title{
    text-align: center;
    padding-bottom: 0.3rem;
    font-size: 0.32rem;
    font-weight: bold;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/user/Agreement.vue